export default "__VITE_ASSET__CqBAkmeP__"